import locales from '@web/locales';
import { BuildType, setBuildType } from '@web/redux/Development';
import { store, useAppDispatch } from '@web/redux/store';
import { ThemeProvider } from '@web/styles/theme';
import CarbonI18nProvider from 'carbon-react/lib/components/i18n-provider';
import Icon from 'carbon-react/lib/components/icon';
import CarbonMessage from 'carbon-react/lib/components/message';
import Typography from 'carbon-react/lib/components/typography';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import styled from 'styled-components';
import Translate from '../../components/Translate/Translate';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[3]};
  height: 100vh;
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[1]};
`;

const Title = styled(Typography)``;
const Message = styled(Typography)``;
const WarningIcon = styled(Icon)``;

const CookiesRequired = () => {
  const [isEmbedded, setIsEmbedded] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const currentPath = window.location.pathname.substring(1);
    const embeddedEntryPoints = ['external-auth'];
    const isEmbeddedMode = embeddedEntryPoints.includes(currentPath);

    dispatch(setBuildType(isEmbeddedMode ? BuildType.embedded : BuildType.default));

    setIsEmbedded(isEmbeddedMode);
  }, [dispatch]);

  return (
    <Root>
      <WarningIcon type="warning" fontSize="extra-large" />
      <TextWrapper>
        <Title variant="h3">
          <Translate scope={'cookieRequirements.Title'} />
        </Title>
        <Message variant="big">
          <Translate scope={'cookieRequirements.Message'} />
        </Message>
        <CarbonMessage mt={3} showCloseIcon={false} open>
          <Translate
            markdown
            scope={'cookieRequirements.Directions'}
            options={{ target: isEmbedded ? 'intacct.com' : window.location.hostname }}
          />
        </CarbonMessage>
      </TextWrapper>
    </Root>
  );
};

export const CookiesRequirements = () => {
  // Initialize the necesary UI providers.
  return (
    <Provider store={store}>
      {/* I18nProvider is not typed properly */}
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <CarbonI18nProvider locale={locales.en}>
        <ThemeProvider>
          <CookiesRequired />
        </ThemeProvider>
      </CarbonI18nProvider>
    </Provider>
  );
};
